import { StoreBase } from "@app/services/stores/shared/StoreBase";
import { volatileStorage } from "@app/services/stores/shared/VolatileStorage";
import { Injectable } from "@angular/core";

type UserState = {
    clientId: string;
    email: string;
    firstName: string;
    lastName: string;
    name: string;
    hoaHomeownerId: number;
    ssoOrigin: string;
    uid: string;
    selectedPropertyId: number;
    previousPropertyGroupId: number;
}

@Injectable()
export class UserStore extends StoreBase<UserState> {
    constructor() {
        super("hoapass_user_", volatileStorage)
    }

    getClientId(): string {
        return this.get("clientId")
    }

    setClientId(value: string) {
        this.set("clientId", value)
    }

    getEmail(): string {
        return this.get("email")
    }

    setEmail(value: string) {
        this.set("email", value)
    }

    getFirstName(): string {
        return this.get("firstName")
    }

    setFirstName(value: string) {
        this.set("firstName", value)
    }

    getLastName(): string {
        return this.get("lastName")
    }

    setLastName(value: string) {
        this.set("lastName", value)
    }

    getName(): string {
        return this.get("name")
    }

    setName(value: string) {
        this.set("name", value)
    }

    getHoaHomeownerId(): number {
        return this.get("hoaHomeownerId")
    }

    setHoaHomeownerId(value: number) {
        this.set("hoaHomeownerId", value)
    }

    getUid(): string {
        return this.get("uid")
    }

    setUid(value: string) {
        this.set("uid", value)
    }

    getSelectedPropertyId(): number {
        return this.get("selectedPropertyId");
    }

    setSelectedPropertyId(value: number) {
        this.set("selectedPropertyId", value);
    }

    getPreviousPropertyGroupId(): number {
        return this.get("previousPropertyGroupId");
    }

    setPreviousPropertyGroupId(value: number) {
        this.set("previousPropertyGroupId", value);
    }

    getSsoOrigin(): string {
        return this.get('ssoOrigin');
    }

    setSsoOrigin(value: string) {
        this.set('ssoOrigin', value);
    }
}
